import { cssVariableStyles, constants } from '@newsela/angelou';
const { generateTooltipDialogVariables } = cssVariableStyles;

export const tooltipDialogBackgroundWhite500 = generateTooltipDialogVariables({ backgroundColor: constants.colors.ui.white[500] });
export const tooltipDialogBackgroundGreyExtraLight500 = generateTooltipDialogVariables({ backgroundColor: constants.colors.ui.neutral[500] });
